jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   // $( document ).on( "variant:changed", function( evt ) {
	   //   // console.log( evt.currentVariant );
	   //   // $('[data-variant-toggle]').hide(0);
	   //   // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   // });

  
// $( document ).on( "variant:changed", function( evt ) {
//   console.log(evt.currentVariant.id)
//   document.querySelector(`.main_product_hiddens select[data-groups-pr-sl] option[value="${evt.currentVariant.id}"]`).selected = true;
// });


// const cartFusionVariantPre = document.querySelector(`.cartFusion_fbt_item select option[value="${window.location.search.split('=').pop()}"]`);
// if (cartFusionVariantPre) {
//   cartFusionVariantPre.selected = true;

//   if (cartFusionVariantPre.disabled === true) {
//     // console.log('soldout')
//     document.querySelector('.cartFusion_fbt_action_control').style.display = 'none';
//     document.querySelector('.cartFusion_fbt_action_trigger').style.display = 'none';
//     document.querySelector('.soldOutButton').removeAttribute('hidden');
//   } else {
//     // console.log('instock')
//     document.querySelector('.cartFusion_fbt_action_control').style.display = 'block';
//     document.querySelector('.cartFusion_fbt_action_trigger').style.display = 'block';
//     document.querySelector('.soldOutButton').setAttribute('hidden', '');
//   }
// }

// $( document ).on( "variant:changed", function( evt ) {
// // document.querySelector(.cartFusion_fbt_item select option[value="${evt.currentVariant.id}"]).selected = true;
// const cartFusionVariant = document.querySelector(`.cartFusion_fbt_item select option[value="${evt.currentVariant.id}"]`);

// if (cartFusionVariant) {
//   cartFusionVariant.selected = true;

//   if (cartFusionVariant.disabled === true) {
//     // console.log('soldout')
//     document.querySelector('.cartFusion_fbt_action_control').style.display = 'none';
//     document.querySelector('.cartFusion_fbt_action_trigger').style.display = 'none';
//     document.querySelector('.soldOutButton').removeAttribute('hidden');
//   } else {
//     // console.log('instock')
//     document.querySelector('.cartFusion_fbt_action_control').style.display = 'block';
//     document.querySelector('.cartFusion_fbt_action_trigger').style.display = 'block';
//     document.querySelector('.soldOutButton').setAttribute('hidden', '');
//   }
// }

document.querySelectorAll('#CustomSizeTab input').forEach((ele) => {
  ele.addEventListener("input", function () {
    if (this.value < 0) {
        this.value = 0;
    }
  });
});
  $(document).on("variant:changed", function (evt) {
    // console.log(evt.currentVariant.title);
    document.querySelector(`.cartFusion_fbt_item select option[value="${evt.currentVariant.id}"]`).selected = true;
    // document.querySelector(`.sr4-shoppay-custom-btn option[value="${evt.currentVariant.id}"]`).selected = true;
    if (evt.currentVariant.title.includes('Custom')) {
        document.querySelectorAll('#CustomSizeTab input').forEach((ele) => {
            ele.removeAttribute("disabled");
        });
    } else {
        document.querySelectorAll('#CustomSizeTab input').forEach((ele) => {
            ele.setAttribute("disabled", "disabled");
        });
    };
  });

  document.querySelectorAll('#CustomSizeTab input').forEach((inp)=>{
    inp.addEventListener('input',()=>{
        document.querySelector(`.cartFusion_fbt_wrapper input[id="${inp.id}"]`).value = inp.value;
    })
})
});